import React, { useState } from 'react';
import {
    Avatar,
    Badge,
    Box,
    Card,
    ListItem,
    ListItemAvatar,
    ListItemText
} from '@mui/material'

export default function CardListItem(props) {

    const { avatar, item, isActive, isEnabled, primary, secondary } = props

    const [itemHover, setItemHover] = useState(false)

    return (
        <ListItem
            sx={{
                backgroundColor: itemHover ? 'rgba(70, 90, 70, 0.5)' : 'rgba(30, 50, 30, 0.2)',
                backdropFilter: 'blur(4px)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: 2,
                cursor: (isEnabled ?? true) ? 'pointer' : 'default',
                transition: 'background-color 0.1s ease-in-out',
            }}
            onMouseEnter={() =>  setItemHover(true)}
            onMouseLeave={() => setItemHover(false)}
            onClick={(event) => item?.onClick ? (isEnabled ?? true) && item.onClick(event) : console.log('Not Implemented')}
            secondaryAction={item?.action}
        >
            {avatar && 
                <ListItemAvatar>
                    <Badge
                        overlap='circular'
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right'}}
                        badgeContent={
                            (isActive ?? false)
                            ?
                            <Box
                                position={'absolute'}
                                right={0}
                                m={'10px'}
                                borderRadius={'5px'}
                                width={'10px'}
                                height={'10px'}
                                sx={{
                                    backgroundColor: 'rgb(92, 230, 92)',
                                    boxShadow: '0 0px 5px rgba(0, 0, 0, 1)'
                                }}
                            />
                            :
                            <></>
                        }
                    >
                        <Avatar
                            src={avatar}
                            children={'K'} // If image broken, then fallback
                            sx={{
                                backgroundColor: 'rgb(0, 0, 0)',
                                color: 'rgb(187, 234, 178)',
                                fontWeight: 'bold'
                            }}
                        />
                    </Badge>
                </ListItemAvatar>
            }
            <ListItemText
                sx={{
                    '& .MuiListItemText-primary': {
                        color: 'rgba(240, 255, 240, 1)',
                        fontWeight: 'bold',
                        wordBreak: 'break-word',
                    },
                    '& .MuiListItemText-secondary': {
                        color: 'rgba(160, 179, 160, 1)',
                        fontSize: '10px',
                        fontStyle: 'italic',
                        wordBreak: 'break-word',
                        // alignItems: 'center'
                    }
                }}
                primary={primary ?? ''}
                secondary={secondary ?? ''}
            />
        </ListItem>
    )
}